<ng-container *ngIf="!debouncedLoading; else tmpLoading">
  <ng-content></ng-content>
</ng-container>

<ng-template #tmpLoading>
  <tui-loader size="l" [showLoader]="true" [inheritColor]="true" [overlay]="true" class="loader-wrapper"></tui-loader>
</ng-template>
